import React from "react";

const DirectorSection = ({ data }) => {
  const name = data?.title?.[0]?.value || "Title not available";
  const designation =
    data?.field_designation?.[0]?.value || "Title not available";
  const imageUrl = data?.field_profile_image?.[0]?.url || "Title not available";

  return (
    <div className="col-12 col-sm-12 col-md-4 col-lg-4 chairmanpr">
      <div className="chief-director">
        <div className="img-sec">
          <img src={imageUrl} alt={""} />
        </div>
        <div className="desc-sec">
          <h2>{name}</h2>
          <p>{designation}</p>
        </div>
      </div>
    </div>
  );
};

export default DirectorSection;
